export const GITHUB_URL = "https://github.com/i-am-neon";
export const TWITTER_URL = "https://twitter.com/i__am__neon";
export const EMAIL_URL = "mailto:0xNeon@protonmail.com";

